export default "__VITE_ASSET__C3CuF21K__"